{
    "ControlsAgentButtonTitle": "Toon alle beschikbare bedieningselementen voor de agent",
    "ControlsDeviceButtonTitle": "Toon alle beschikbare bedieningselementen voor het apparaat",
    "NAME": "StaticAgentControls"
}